export default __webpack_public_path__ + "static/media/MaisonNeue-BoldItalic.adeec51a.woff2";